import activityCard from "../assets/GroupVenture/activityCard.png";
import editProfile from "../assets/GroupVenture/editProfile.png";
import homepage from "../assets/GroupVenture/homepage.png";
import profile from "../assets/GroupVenture/profile.png";
import signUp from "../assets/GroupVenture/activityCard.png";
import tinPet from "../assets/TinPet/tinPet.gif";
import matchingPage from "../assets/TinPet/matchingPage.png"
import tinCard from "../assets/TinPet/tinCard.png"
import createProfile from "../assets/TinPet/createProfile.png"
import homepageJam from "../assets/JAM/homepageJam.png"
import dashboard from "../assets/JAM/dashboard.png"
import todo from "../assets/JAM/todo.png"
import expenses from "../assets/JAM/expenses.png"
import chat from "../assets/JAM/chat.png"
import todo1 from "../assets/TODO/todo1.png"
import todo2 from "../assets/TODO/todo2.png"
import todo3 from "../assets/TODO/todo3.png"
import contact from "../assets/Cowboys/contact.png"
import hero from "../assets/Cowboys/hero.png"
import impressions from "../assets/Cowboys/impressions.png"
import team from "../assets/Cowboys/team.png"
import telzoznam from "../assets/TV/telzoznam.gif"
import dnes from "../assets/TV/dnes.png"
import zajtra from "../assets/TV/zajtra.png"
import photo from "../assets/PhotoWeb/photo.png"
import example_photos from "../assets/PhotoWeb/example_photos.png"
import photoweb_home from "../assets/PhotoWeb/photowebhome.png"
import photoweb_portfolio from "../assets/PhotoWeb/photoweb_portfolio.png"

const projects = [
  {
    id: 1,
    images: [
      { id: 1, url: homepageJam },
      { id: 2, url: dashboard },
      { id: 3, url: todo },
      { id: 4, url: expenses },
      { id: 5, url: chat }],
    name: "JAM",
    description:
      `<h5>JAM (Join, Arrange, Manage) - an app designed to streamline expense splitting, task planning, has a built-in chat feature.</h5> Features include: <li>Adding events to calendar</li><li>Splitting bills between participants</li><li>Adding tasks</li><li>Marking tasks as done</li><li>Restoring password with email</li><li>Real-time chat feature for communication</li>
  
   <h6>App was built with:
   <i class="iconify icon-tooltip" data-icon="logos:typescript-icon" data-title="TypeScript"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:react" data-title="React"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:redux" data-title="Redux Toolkit"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:socket-io" data-title="Socket.io"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:express" data-title="Express"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:postgresql" data-title="PostgreSQL"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:cloudinary" data-title="Cloudinary"></i>.
 </h6>`,

    link: "https://www.jamwiz.app/"
  },
  {
    id: 2,
    images: [
      { id: 1, url: homepage },
      { id: 2, url: signUp },
      { id: 3, url: profile },
      { id: 4, url: editProfile },
      { id: 5, url: activityCard }],
    name: "GroupVenture",
    description:
      `<h5>GroupVenture is a web app which allows users to create, manage, and discover exciting activities.</h5> Features include: <li>User profiles and activities info</li><li>Searching place on the map by address</li><li>Adding place address by clicking on the map</li>
   <h6>
   App was built with:
   <i class="iconify icon-tooltip" data-icon="logos:google-maps" data-title="Google Map"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:redis" data-title="Redis"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:react" data-title="React"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:typescript" data-title="TypeScript"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:express" data-title="Express"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:postgresql" data-title="PostgreSQL"></i>,
   <i class="iconify icon-tooltip" data-icon="logos:cloudinary" data-title="Cloudinary"></i>.
 </h6>`,

    link: "https://group-venture.vercel.app/"
  },
  {
    id: 3,
    images: [{ id: 1, url: tinPet },
    { id: 2, url: createProfile },
    { id: 3, url: matchingPage },
    { id: 4, url: tinCard },],
    name: "TinPet",
    description:
      `<h5>TinPet is a web app which allows dog owners to connect and match with each other.</h5> Features include: <li>User profiles and dog information</li><li>Matching cards</li><li>Real-time chat feature for communication</li>
    <h6> App was built with: 
    <i class="iconify icon-tooltip" data-icon="logos:react" data-title="React"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:typescript" data-title="TypeScript"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:express" data-title="Express"></i>,
    <i class="iconify icon-tooltip" data-icon="devicon:mongoose" data-title="Mongoose"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:jwt" data-title="JWT"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:cloudinary" data-title="Cloudinary"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:socket-io" data-title="Socket.io"></i>.</h6>`,
    link: "https://tinpetbcn.vercel.app/"
  },
  {
	id: 4,
	images: [{ id: 1, url: hero },
	{ id: 2, url: impressions },
	{ id: 3, url: team },
	{ id: 4, url: contact },
	],
	name: "Spacecowboys",
	description: `<h5>Spacecowboys is an interactive and responsive HTML template built as a portfolio example.</h5>
	<h6> App was built with: 
	<i class="iconify icon-tooltip" data-icon="logos:vue" data-title="Vue"></i>,
	<i class="iconify icon-tooltip" data-icon="logos:typescript" data-title="TypeScript"></i>.
	</h6>`,

	link: "https://spacecowboys-vue.vercel.app/"
  },
  {
    id: 5,
    name: "Photo Portfolio Web",
    images: [
    { id: 1, url: photoweb_home },
    { id: 2, url: photoweb_portfolio },
	{ id: 3, url: example_photos },
	{ id: 4, url: photo }
    ],
    description: `<h5>Photo Portfolio Web is a responsive HTML template built to represent photographer portfolio.</h5>
    <h6> App was built with: 
    <i class="iconify icon-tooltip" data-icon="logos:angular" data-title="Angular"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:typescript" data-title="TypeScript"></i>.
	<i class="iconify icon-tooltip" data-icon="logos:bulma" data-title="Bulma"></i>.
    </h6>`,
    link: "https://anna-k-photography.social/"
  },
  {
    id: 6,
    images: [{ id: 1, url: todo1 },
    { id: 2, url: todo2 },
    { id: 3, url: todo3 },
    ],
    name: "TODO planner",
    description:
      `Features include: <li>Creating lists of todos</li><li>Adding todos to each list</li><li>Setting deadlines for todos</li><li>Deleting todos or lists</li><li>Toggling todos</li><li>Filtering todos</li><li>Search by name or description</li>
    <h6> App was built with: 
    <i class="iconify icon-tooltip" data-icon="logos:react" data-title="React"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:typescript" data-title="TypeScript"></i>,
    MockAPI, Joi.
    Codebase: <a href="https://github.com/AnnaKucherenko1/todo" style="text-decoration: underline">GitHub<a>
    </h6>`,
    link: "https://annakucherenko-todo-list.netlify.app/"
  },
  {
    id: 7,
    name: "Televízny Program",
    images: [{ id: 1, url: telzoznam },
    { id: 2, url: dnes },
    { id: 3, url: zajtra },
    ],
    description: `<h5>Televízny Program is a user-friendly SPA designed to help you effortlessly explore TV schedules for three different channels.</h5>
    Features include: <li>Dynamic Schedules: Easily access TV schedules for three channels with data fetched on-demand as you scroll.</li>
    <h6> App was built with: 
    <i class="iconify icon-tooltip" data-icon="logos:vue" data-title="Vue"></i>,
    <i class="iconify icon-tooltip" data-icon="logos:typescript" data-title="TypeScript"></i>.
    </h6>`,
    link: "https://github.com/AnnaKucherenko1/Telev-zny-program-VUE"
  }
];

export default projects;
